import React from 'react';
import { Label } from '@cian/ui-kit';

import * as s from './RubricButton.css';

export interface IRubricLink {
  children: string;
  url?: string;
  noIndex?: boolean;
  onClick?(e: React.MouseEvent): void;
}

/**
 * Кнопка рубрики
 */
export const RubricButton = ({ children, url, noIndex, onClick }: IRubricLink) => {
  if (!url) {
    return (
      <Label background="background-secondary" color="text-primary-default" truncate>
        {children}
      </Label>
    );
  }

  return (
    <a
      href={url}
      className={s['link']}
      data-web-ui-test-id={'RubricButton'}
      onClick={onClick}
      rel={noIndex ? 'nofollow' : undefined}
      itemProp="url"
    >
      <Label background="background-secondary" color="text-primary-default" truncate>
        {children}
      </Label>
    </a>
  );
};
